import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  constructor(private title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    let currentRoute = routerState.root.firstChild;
    // Traverse to the last child route
    while (currentRoute?.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    // Extract the title from the last child route
    const routeTitle = currentRoute?.title;

    if (routeTitle) {
      this.title.setTitle(`Orderna | ${routeTitle}`);
    } else {
      this.title.setTitle('Orderna');
    }
  }
}
